import React, {useState} from 'react';
import {
    Box,
    InputAdornment,
    Popover,
    TextField,
    Typography
} from '@mui/material';

import {ChromePicker} from 'react-color';

const ColorPicker = ({label, name, value, onChange}) => {

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColorChange = (color) => {
        onChange({
            target: {
                name,
                value: color.hex
            }
        });
    };

    return (
        <Box>
            <TextField
                fullWidth
                label={label}
                name={name}
                value={value}
                onClick={handleClick}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Box
                                sx={{
                                    width: 24,
                                    height: 24,
                                    backgroundColor: value,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px'
                                }}
                            />
                        </InputAdornment>
                    ),
                    readOnly: true
                }}
            />

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <Box sx={{p: 2}}>
                    <Typography variant="subtitle2" gutterBottom>
                        {label}
                    </Typography>

                    <ChromePicker
                        color={value}
                        onChangeComplete={handleColorChange}
                    />
                </Box>
            </Popover>
        </Box>
    );
};

export default ColorPicker;